var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineBannerIcGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_4652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56864 0C3.00032 0 2.45527 0.225764 2.05341 0.627629C1.65155 1.02949 1.42578 1.57454 1.42578 2.14286V17.8571C1.42578 18.4254 1.65155 18.9706 2.05341 19.3724C2.45527 19.7743 3.00031 20 3.56864 20H16.4258C16.9941 20 17.5392 19.7743 17.9411 19.3724C18.3429 18.9706 18.5686 18.4254 18.5686 17.8571V6.42857C18.5686 6.23913 18.4934 6.05744 18.3595 5.9235L12.6451 0.20921C12.5112 0.0752549 12.3295 0 12.1401 0H3.56864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09016 7.13867C8.78063 7.13867 8.52971 7.3896 8.52971 7.69913V9.92807H6.30069C5.99116 9.92807 5.74023 10.179 5.74023 10.4885V12.31C5.74023 12.6196 5.99116 12.8705 6.30069 12.8705H8.52963V15.0994C8.52963 15.409 8.78056 15.6598 9.09009 15.6598H10.9116C11.2211 15.6598 11.472 15.409 11.472 15.0994L11.4721 12.8705H13.701C14.0106 12.8705 14.2615 12.6196 14.2615 12.31V10.4885C14.2615 10.179 14.0106 9.92807 13.701 9.92807H11.4721V7.69913C11.4721 7.3896 11.2212 7.13867 10.9116 7.13867H9.09016Z",
    fill: "#1F956A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_4652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBannerIcGreen);
export default __webpack_public_path__ + "static/media/timeline-banner-ic-green.5b57532e9c15c4f07ab4d432caba55f1.svg";
export { ForwardRef as ReactComponent };